import React, { Component } from "react";
import { Dialog } from "@blueprintjs/core";
import TranslatedPage from "../TranslatedPage";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { Group, Dashboard, Face } from "@material-ui/icons/";
import heroPoster from "../../styles/images/hero.png";
import heroVideo from "../../styles/images/video-banner.mp4";
class HomeHero extends Component {
  state = {
    show_modal: false,
  };

  handleModalClose = () => {
    this.setState({ show_modal: false });
  };

  handleModalOpen = () => {
    this.setState({ show_modal: true });
  };

  render() {
    return (
      <section className="hero prylpoolen-hero">
        <div className="video-wrapper">
          <video
            className="background-video"
            loop
            autoPlay
            muted
            playsInline
            controls={false}
            poster={heroPoster}
          >
            <source src={heroVideo} type="video/mp4" />
          </video>
        </div>
        <div className="main-container">
          <div className="content-wrapper flex-center-space-between">
            <div className="main-hero-copy">
              <h1>
                <TranslatedPage path="home.content_blocks.hero_prylpoolen.heading" />
              </h1>
              <h2 className="light opacity90">
                <TranslatedPage path="home.content_blocks.hero_prylpoolen.subheading" />
              </h2>
              <div className="selling-points">
                <div className="item flex-center-left">
                  <div className="icon-wrapper">
                    <Group className="icon" />
                  </div>
                  <span>
                    <TranslatedPage path="home.content_blocks.hero_prylpoolen_rent_to_share.heading" />
                  </span>
                </div>
                <div className="item flex-center-left">
                  <div className="icon-wrapper">
                    <Dashboard className="icon" />
                  </div>
                  <span>
                    <TranslatedPage path="home.content_blocks.hero_prylpoolen_rent_sharing_boxes.heading" />
                  </span>
                </div>
                <div className="item flex-center-left">
                  <div className="icon-wrapper">
                    <Face className="icon" />
                  </div>
                  <span>
                    <TranslatedPage path="home.content_blocks.hero_prylpoolen_rent_borrow.heading" />
                  </span>
                </div>
              </div>
              {/* <Button */}
              {/*   icon="play" */}
              {/*   onClick={this.handleModalOpen} */}
              {/*   text={I18n.t("home.hero.how_it_works")} */}
              {/*   className="play-video-cta" */}
              {/* /> */}
            </div>
          </div>
        </div>
        <Dialog
          onClose={this.handleModalClose}
          title={I18n.t("home.hero.how_it_works")}
          autoFocus={true}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          enforceFocus={true}
          isOpen={this.state.show_modal}
          usePortal={true}
          className="how-it-works-video-modal"
        >
          <div className="video-modal-square">
            <iframe
              title={I18n.t("home.hero.how_it_works")}
              src="https://player.vimeo.com/video/366843044?autoplay=1&color=F16667&byline=0&portrait=0"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </Dialog>
      </section>
    );
  }
}
const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(HomeHero);
